<template>
	<div class="zl_box">
		<div>
			<div class="item_box">
				<div><span style="font-weight: 650;">搜索属性</span>
					<el-tooltip placement="right-start">
						<div slot="content" class="el_tip_box">
							<div>
								搜索属性为产品属性的重要属性，有助于买家通过筛选找到产品
							</div>
							<div class="item_eltip" style="margin-top: 20px">
								<span>填写超过70%的属性</span><span>30分</span>
							</div>
							<div class="item_eltip">
								<span>填写超过50%的属性</span><span>22.5分</span>
							</div>
							<div class="item_eltip">
								<span>填写2个或更多属性</span><span>15分</span>
							</div>
							<div class="item_eltip">
								<span>填写2个已下属性</span><span>0分</span>
							</div>
						</div>
						<img :src="urlQueImg" class="item_img" alt/>
					</el-tooltip>
				</div>
				<div>分数：<span style="margin-left: 5px" v-if="score && score.length > 0">{{(score[0].weight * score[0].rating)/100 }}</span></div>
			</div>
			<div style="padding: 6px 0" v-if="score && score.length > 0">
				至少填写{{score[0].improve_at_least}}个属性可得最大分数
			</div>
			<div v-if="score && score.length > 0 && score[0].improve_attributes && score[0].improve_attributes.length > 0"
				 v-for="(item,index) in score[0].improve_attributes" :key="index" style="padding: 3px">
				--<span style="margin-left: 8px">{{item.name}}</span>
			</div>
		</div>
		<div style="margin-top:8px">
			<div class="item_box">
				<div><span style="font-weight: 650;">附加属性</span>
					<el-tooltip placement="right-start">
						<div slot="content" class="el_tip_box">
							<div>
								其他属性为产品属性的附加属性，有助于买家了解更多有关产品的信息
							</div>
							<div class="item_eltip" style="margin-top: 20px">
								<span>填写超过50%的属性</span><span>20分</span>
							</div>
							<div class="item_eltip">
								<span>填写2个或更多属性</span><span>12.5分</span>
							</div>
							<div class="item_eltip">
								<span>填写2个已下属性</span><span>0分</span>
							</div>
						</div>
						<img :src="urlQueImg" class="item_img" alt/>
					</el-tooltip>
				</div>
				<div>分数：<span style="margin-left: 5px">{{(score[1].weight * score[1].rating)/100 }}</span></div>
			</div>
			<div style="padding: 6px 0">
				至少填写{{score[1].improve_at_least}}个属性可得最大分数
			</div>
			<div v-if="score && score.length > 1 && score[1].improve_attributes && score[1].improve_attributes.length > 0"
				 v-for="(item,index) in score[1].improve_attributes" :key="index" style="padding: 3px">
				--<span style="margin-left: 8px">{{item.name}}</span>
			</div>
		</div>
		<div style="margin-top:8px">
			<div class="item_box">
				<div><span style="font-weight: 650;">富内容和描述</span>
					<el-tooltip placement="right-start">
						<div slot="content" class="el_tip_box">
							<div>
								超过500个字符信息的描述有助于买家了解更多有关产品的信息并提高信任度
							</div>
							<div class="item_eltip" style="margin-top: 20px">
								<span>填写富内容</span><span>20分</span>
							</div>
							<div class="item_eltip">
								<span>填写超过500个字符的描述</span><span>10分</span>
							</div>
							<div class="item_eltip">
								<span>填写超过100个字符的描述</span><span>5分</span>
							</div>
							<div class="item_eltip">
								<span>填写低于100个字符的描述</span><span>0分</span>
							</div>
						</div>
						<img :src="urlQueImg" class="item_img" alt/>
					</el-tooltip>

				</div>
				<div>分数：<span style="margin-left: 5px">{{(score[2].weight * score[2].rating)/100 }}</span></div>
			</div>
			<div style="padding: 6px 0">
				至少填写{{score[2].improve_at_least}}个属性可得最大分数
			</div>
			<div v-if="score && score.length > 2 && score[2].improve_attributes && score[2].improve_attributes.length > 0"
				 v-for="(item,index) in score[2].improve_attributes" :key="index" style="padding: 3px">
				--<span style="margin-left: 8px">{{item.name}}</span>
			</div>
		</div>
		<div style="margin-top:8px">
			<div class="item_box">
				<div><span style="font-weight: 650;">图片和视频</span>
					<el-tooltip placement="right-start">
						<div slot="content" class="el_tip_box">
							<div>
								图片和视频有助于买家从查看产品并对齐外观产生完整映象
							</div>
							<div class="item_eltip" style="margin-top: 20px">
								<span>添加视频封面+视频+3张图片</span><span>25分</span>
							</div>
							<div class="item_eltip">
								<span>添加视频封面</span><span>12.5分</span>
							</div>
							<div class="item_eltip">
								<span>添加视频</span><span>7.5分</span>
							</div>
							<div class="item_eltip">
								<span>添加3个图片或更多</span><span>5分</span>
							</div>
							<div class="item_eltip">
								<span>添加少于3个图片</span><span>0分</span>
							</div>
						</div>
						<img :src="urlQueImg" class="item_img" alt/>
					</el-tooltip>
				</div>
				<div>分数：<span style="margin-left: 5px">{{(score[3].weight * score[3].rating)/100 }}</span></div>
			</div>
			<div style="padding: 6px 0 ">
				至少填写{{score[3].improve_at_least}}个属性可得最大分数
			</div>
			<div v-if="score && score.length > 3 && score[3].improve_attributes && score[3].improve_attributes.length > 0"
				 v-for="(item,index) in score[3].improve_attributes" :key="index" style="padding: 3px">
				--<span style="margin-left: 8px">{{item.name}}</span>
			</div>
		</div>

	</div>
</template>
<script>
	export default {
		name: 'mytipComp',
		props: {
			score: {
				type: Array,
				default() {
					return [{},{},{},{}];
				},
			}
		},
		data() {
			return {
				//问号图标的地址
				urlQueImg:require('@/assets/images/wenhao.png'),

			}
		},
		methods: {}
	}
</script>
<style lang="scss" scoped>
	.zl_box{
		width: 320px;
		padding: 10px 20px 30px 20px;
		font-size: 16px;
		max-height: 500px;
		overflow: auto;
	}
	.item_box{
		display: flex;
		justify-content: space-between
	}
	.item_img{
		height: 16px;
		width: 16px;
		margin-left: 5px;
		cursor: pointer
	}
	.el_tip_box{
		width: 360px;
		font-size: 18px;
		background: rgb(39,39,39);
		border-radius: 10px;
		padding: 15px;
		color: whitesmoke;

	}
	.item_eltip{
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
	}
</style>
